/** Ordena una copia de `items` por un campo string, con `Intl.Collator`
 *  (numérico + case-insensitive) — mismo criterio que ya usaba
 *  `DatabaseBase._sort` para los catálogos REST. */
export function sortByField<T>(
  items: readonly T[],
  fieldName: string,
  order: "asc" | "desc" = "asc",
): T[] {
  const factor = order === "desc" ? -1 : 1;
  const collator = new Intl.Collator(undefined, { sensitivity: "base", numeric: true });
  return [...items].sort(
    (a, b) =>
      factor *
      collator.compare(
        String((a as unknown as Record<string, unknown>)[fieldName] ?? ""),
        String((b as unknown as Record<string, unknown>)[fieldName] ?? ""),
      ),
  );
}
